<script lang="ts">
  import { computePosition, flip, shift, type VirtualElement } from '@floating-ui/dom'
  import { getContext } from 'svelte'

  const { children } = $props()
  const { opened, position } = getContext<ContextMenuContext>('context-menu')

  let containerElement = $state<HTMLDivElement>()

  const computeMenuPosition = async (container: HTMLDivElement, x: number, y: number) => {
    const virtualElement: VirtualElement = {
      getBoundingClientRect: () => ({
        x,
        y,
        top: y,
        left: x,
        right: x,
        bottom: y,
        width: 0,
        height: 0,
      }),
    }

    const { x: computedX, y: computedY } = await computePosition(virtualElement, container, {
      strategy: 'fixed',
      placement: 'bottom-start',
      middleware: [flip(), shift({ padding: 16 })],
    })

    Object.assign(container.style, {
      left: `${computedX}px`,
      top: `${computedY}px`,
    })
  }

  $effect(() => {
    if ($opened && containerElement) {
      computeMenuPosition(containerElement, $position.x, $position.y)
    }
  })
</script>

{#if $opened}
  <div
    bind:this={containerElement}
    class="context-menu-content"
  >
    {@render children?.()}
  </div>
{/if}

<style lang="scss">
  .context-menu-content {
    background: var(--context-menu-background);
    border: 1px solid var(--context-menu-border);
    color: var(--context-menu-foreground);
    border-radius: 0.25rem;
    display: flex;
    flex-direction: column;
    font-size: 0.75rem;
    min-width: 7.5rem;
    position: fixed;
    z-index: 1001; // Gizmos are 1000

    :global(> :first-child:is(div) > div) {
      border-top-right-radius: calc(0.25rem - 1px);
      border-top-left-radius: calc(0.25rem - 1px);
    }

    :global(> :last-child:is(div) > div),
    :global(> :last-child:is(button)) {
      border-bottom-right-radius: calc(0.25rem - 1px);
      border-bottom-left-radius: calc(0.25rem - 1px);
    }
  }
</style>
